export default {
    apiKey: "AIzaSyCINtQ3nwtTBUN2DqT6ih-M_wa3D74uznU",
    authDomain: "parksdev-f8a63.firebaseapp.com",
    projectId: "parksdev-f8a63",
    storageBucket: "parksdev-f8a63.appspot.com",
    messagingSenderId: "245008900328",
    appId: "1:245008900328:web:f3a5456c36c2a98607295d",
  };  